// Used for form validation and converting state codes to names.
// NOT the same as US_STATE.

import { StatesWithoutTerritories } from "../types/usState";

export const listOfUSAStates: Record<StatesWithoutTerritories, string> = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "Washington, DC",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

/**
 * Incomplete mapping of US states to timezones. Only states with pure timezones
 * are included (i.e. the entire state lies in that timezone).
 */
export const usaStatesWithPureTimezones = {
  AL: "America/Chicago" as const,
  AK: "America/Anchorage" as const,
  AZ: "America/Phoenix" as const,
  AR: "America/Chicago" as const,
  CA: "America/Los_Angeles" as const,
  CO: "America/Denver" as const,
  CT: "America/New_York" as const,
  DE: "America/New_York" as const,
  DC: "America/New_York" as const,
  GA: "America/New_York" as const,
  HI: "Pacific/Honolulu" as const,
  IL: "America/Chicago" as const,
  IA: "America/Chicago" as const,
  LA: "America/Chicago" as const,
  ME: "America/New_York" as const,
  MD: "America/New_York" as const,
  MA: "America/New_York" as const,
  MN: "America/Chicago" as const,
  MS: "America/Chicago" as const,
  MO: "America/Chicago" as const,
  MT: "America/Denver" as const,
  NV: "America/Los_Angeles" as const,
  NH: "America/New_York" as const,
  NJ: "America/New_York" as const,
  NM: "America/Denver" as const,
  NY: "America/New_York" as const,
  NC: "America/New_York" as const,
  OH: "America/New_York" as const,
  OK: "America/Chicago" as const,
  PA: "America/New_York" as const,
  RI: "America/New_York" as const,
  SC: "America/New_York" as const,
  UT: "America/Denver" as const,
  VT: "America/New_York" as const,
  VA: "America/New_York" as const,
  WA: "America/Los_Angeles" as const,
  WV: "America/New_York" as const,
  WI: "America/Chicago" as const,
  WY: "America/Denver" as const,
};
